import React, { useState, memo } from "react"

const ToggleButton = ({ idTrackSuggestion, handleSelect, grau, name, id, totalContents , ignoreCheck}) => {
  const [selected, setSelected] = useState(false)

  const _handleOnPress = (event) => {
    if (totalContents === 0) return;
    if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
      setSelected(!selected)
      handleSelect(idTrackSuggestion, !selected)
    }
  }

  if(!grau) {
    return (
      <label
        id={id} 
        className={`btn-limit btn-grey interesses-space ${grau !== "" && "active"}`}
        onClick={_handleOnPress}
        onKeyDown={_handleOnPress}
        tabIndex={totalContents === 0 ? -1 : 0}
        role="button"
        aria-disabled={totalContents === 0}
        style={{ cursor: totalContents === 0 ? 'not-allowed' : 'pointer' }}
      >
        {name} {totalContents > 0 && <span className="badge text-gray-dark">{totalContents}</span>}
      </label>
    )
  }

  return (
    <label
      style={{borderRadius: '.25rem', cursor: totalContents === 0 ? 'not-allowed' : 'pointer'}}
      className={`btn btn-grey interesses-space ${grau !== "" && "active"}`}
      id={id}
      onClick={_handleOnPress}
      onKeyDown={_handleOnPress}
      tabIndex={totalContents === 0 ? -1 : 0}
      role="button"
      aria-disabled={totalContents === 0}
    >
      {!ignoreCheck && <input type="checkbox" checked={selected} readOnly />}
      {name} <span className="badge">{totalContents || grau}</span>
    </label>
  )
}

export default memo(ToggleButton)
